
import React from 'react';
import { Award, BookOpen, DollarSign, Users } from 'lucide-react';
import OnboardingLayout from '../../OnboardingLayout';

interface WelcomeScreenProps {
  onNext: () => void;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onNext }) => {
  return (
    <OnboardingLayout
      title="Welcome to DirectPress"
      subtitle="Join a community of independent journalists sharing their expertise directly with readers"
      currentStep={1}
      totalSteps={9}
      onNext={onNext}
      onPrevious={() => {}}
      nextLabel="Get Started"
    >
      <div className="max-w-3xl mx-auto">
        <div className="bg-muted/30 rounded-lg p-6 mb-8">
          <h3 className="text-xl font-semibold mb-4">Our Mission</h3>
          <p className="mb-4">
            DirectPress is built to empower journalists like you to create, share, and monetize 
            your expertise without intermediaries. We believe in direct connections between 
            journalists and their audience.
          </p>
          <p>
            You maintain full editorial control, build your personal brand, and earn fair 
            compensation for your hard work and expertise.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-background rounded-lg p-5 border">
            <div className="flex items-center mb-3">
              <Users className="h-6 w-6 text-primary mr-2" />
              <h4 className="text-lg font-medium">Direct Audience Connection</h4>
            </div>
            <p className="text-muted-foreground">
              Develop a direct relationship with your readers, get their feedback, and grow your audience.
            </p>
          </div>
          
          <div className="bg-background rounded-lg p-5 border">
            <div className="flex items-center mb-3">
              <DollarSign className="h-6 w-6 text-primary mr-2" />
              <h4 className="text-lg font-medium">Fair Compensation</h4>
            </div>
            <p className="text-muted-foreground">
              Set your own subscription rates and get paid directly by your audience with minimal platform fees.
            </p>
          </div>
          
          <div className="bg-background rounded-lg p-5 border">
            <div className="flex items-center mb-3">
              <BookOpen className="h-6 w-6 text-primary mr-2" />
              <h4 className="text-lg font-medium">Editorial Freedom</h4>
            </div>
            <p className="text-muted-foreground">
              Maintain complete editorial control over your content and the stories you want to tell.
            </p>
          </div>
          
          <div className="bg-background rounded-lg p-5 border">
            <div className="flex items-center mb-3">
              <Award className="h-6 w-6 text-primary mr-2" />
              <h4 className="text-lg font-medium">Build Your Brand</h4>
            </div>
            <p className="text-muted-foreground">
              Develop your personal brand and expertise in your field, building an audience that follows your work.
            </p>
          </div>
        </div>
        
        <div className="text-center">
          <p className="text-muted-foreground">
            In the next few steps, we'll help you set up your profile, choose your expertise areas, 
            and prepare to start publishing.
          </p>
        </div>
      </div>
    </OnboardingLayout>
  );
};

export default WelcomeScreen;
